import { FeeType } from '../types';

interface FeeProps {
  type: FeeType;
  value: number;
}

export const calculatePriceWithFee = (ownerSetPrice: number, fee: FeeProps) => {
  let total = Number(ownerSetPrice);
  const feeValue = Number(fee.value);

  if (fee.type === 'FIXED') {
    return total + feeValue;
  }

  total = total + (ownerSetPrice * feeValue) / 100;

  const remainder = total % 5;
  if (remainder < 2) {
    return total - remainder;
  } else {
    return total + (5 - remainder);
  }
};
